import React, { useEffect, useState, Fragment } from "react";
import PropTypes, { string } from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import MessageModal from "../../../UI/Modal/MessageModal";
import { CustomerBiometricsTableContent } from "../../Common/Table/tableContent";
import $ from "jquery";
import ImageUploader from "react-images-upload";
import service from "../service";
import { PageHeader } from "../../../Common";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import { CommonDecryptParam } from '../../../../utils/CommonParams';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  media: {
    height: 140,
  },
}));

export function BiometricsaddEdit(props) {
  const { data, edit } = props.location;
  const [pictures, setPictures] = useState({});
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [addCustomerBiometrics, setAddCustomerBiometrics] = useState({
    CustomerID: 0,
    CustomerBiometricData: 0,
    CustomerBiometricDataTypeID: 0,
    isDefault: true,
    isActive: true,
    CreatedBy: 0,
    CreatedDate: new Date().toISOString(),
    ModifiedBy: 0,
    ModifiedDate: new Date().toISOString(),
  });

  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success",
  });
  const [imageUploaderHidden, setImageUploaderHidden] = useState(false);
  const [imageView, setImageView] = useState(true);
  const [imagePreView, setImagePreView] = useState(true);
  const contentRowNames = ["createdDate"];
  const [customerBiometricsDetails, setCustomerBiometricsDetails] = useState(
    []
  );
  const [imageData, setImageData] = useState();
  const Compress = require("compress.js");
  const compress = new Compress();
  const encriptedTest = props.match.params["id"];
  const id = (encriptedTest !== undefined) ? parseFloat(CommonDecryptParam(props.match.params["id"])) : 0;

  useEffect(() => {
    setAddCustomerBiometrics({
      ...addCustomerBiometrics,
      CustomerID: id,
    });
    getSelectedCustomer();
  }, []);

  async function getSelectedCustomer() {
    var customer = await service.getBiometrics(id, 1);
    setCustomerBiometricsDetails(customer);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  function onSave(e) {
    e.preventDefault();
    service.SaveCustomerBiometrics(pictures, data.customerID);
  }

  function destroyDataTable() {
    $("#example").DataTable().destroy();
  }

  function createDataTable() {
    $("#example").DataTable();
  }

  async function handleRemove(data) {
    const response = await service.RemoveCustomerBiometrics(data.customerBiometricID, 1);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    getSelectedCustomer();
  }

  async function handleSave(e) {
    var customerBiometricCount = [...customerBiometricsDetails];
    let isDefault = false;
    if (customerBiometricCount.length == 0) {
      isDefault = true;
    }

    const response = await service.SaveCustomerBiometrics(pictures, id, isDefault);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    getSelectedCustomer();
    setPictures(null);
    setImagePreView(false);
  }

  function afterSuccessfulyChanged(response) {
    if (response === "Success") {
      clearState();
      setTimeout(() => {
        props.history.push({ pathname: "/Customer" });
      }, 1500);
    }
    getSelectedCustomer();
    setImageView(true);
  }

  function clearState() {
    setAddCustomerBiometrics({
      ...addCustomerBiometrics,
      CustomerBiometricData: "",
    });
  }

  function handleViewClick(customerBiometricsDetails) {
    setImageUploaderHidden(true);
    setImageView(false);
    setImageData(customerBiometricsDetails.customerBiometricData);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function onDrop(picture, pictureDataURLs) {
    if (pictureDataURLs[0] !== undefined) {
      var convertedString = pictureDataURLs[0];
      var fields = convertedString.split(",");
      var name = fields[0];
      compress
        .compress(picture, {
          size: 4,
          quality: 0.25,
          maxWidth: 250,
          maxHeight: 250,
          resize: true,
        })
        .then((data) => {
          setPictures(name + "," + data[0].data);
        });
    }
  }

  async function handleIsDefaultChange(newCustomerBiometricID) {
    var updateScreen = [...customerBiometricsDetails];
    let oldCustomerBiometricID = 0;
    updateScreen.forEach((s) => {
      if (s.customerBiometricID == newCustomerBiometricID) {
        s.isDefault = true;
      } else {
        if (s.isDefault) {
          oldCustomerBiometricID = s.customerBiometricID;
          s.isDefault = false;
        }
      }
    });
    setCustomerBiometricsDetails(updateScreen);
    if (oldCustomerBiometricID != 0) {
      const result = await service.UpdateCustomerBiometricIsDefault(oldCustomerBiometricID, newCustomerBiometricID);
    setMessageModel({
      ...messageModel,
        hidden: false,
        type: result.statusCode,
        disciption: result.message,
      });
    }
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div>
            <div className="card">
              <PageHeader
                title="Add Customer Biometric"
                isButtonEnable={true}
                buttonText="Back to Listing"
                path="/Customer"
              />

              <div className={classes.root}>
                <AppBar position="static" color="#f44336">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="simple tabs example"
                  >
                    <Tab label="Face" {...a11yProps(0)} />
                    <Tab label="Finger" {...a11yProps(1)} />
                  </Tabs>
                </AppBar>
                <TabPanel
                  value={value}
                  index={0}
                  onSubmit={(e) => trackPromise(handleSave(e))}
                >
                  <div hidden={imageUploaderHidden}>
                    <ImageUploader
                      {...props}
                      withIcon={true}
                      singleImage={true}
                      withPreview={imagePreView}
                      buttonText="Choose images"
                      onChange={onDrop}
                      imgExtension={[".jpg", ".png", ".jpeg"]}
                      maxFileSize={5242880}
                    />
                    <input
                      type="button"
                      className="btn btn-primary"
                      value="Save"
                      onClick={(e) => trackPromise(handleSave(e))}
                    />
                  </div>
                  <div hidden={imageView}>
                    <Card className={classes.root}>
                      <CardActionArea>
                        <center>
                          <img src={imageData} width="200" height="200" />
                        </center>
                      </CardActionArea>
                    </Card>
                  </div>

                  <div>
                    <table id="example" className="display dataTable no-footer">
                      <thead>
                        <tr>
                          <th>Create Date</th>
                          <th>Image</th>
                          <th>Delete</th>
                          <th>View</th>
                          <th>Default</th>
                        </tr>
                      </thead>
                      <tbody>
                        <CustomerBiometricsTableContent
                          data={customerBiometricsDetails}
                          contentRowNames={contentRowNames}
                          handleRemoveClick={handleViewClick}
                          handleViewClick={handleViewClick}
                          handleDeleteClick={handleRemove}
                          handleIsDefaultChange={handleIsDefaultChange}
                        />
                      </tbody>
                    </table>
                  </div>
                  <MessageModal
                    hidden={messageModel.hidden}
                    messageType={messageModel.type}
                    messageDescription={messageModel.disciption}
                    clicked={modalDismissHandler}
                  />
                </TabPanel>
                <TabPanel value={value} index={1}></TabPanel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
